export const formatFullName = (
  person?: { firstName?: string; lastName?: string } | null
): string => {
  if (!person) {
    return '';
  }

  return `${person.firstName || ''} ${person.lastName || ''}`.trim();
};
